import { render, staticRenderFns } from "./settingItem.vue?vue&type=template&id=527cde80&scoped=true&"
import script from "./settingItem.vue?vue&type=script&lang=ts&"
export * from "./settingItem.vue?vue&type=script&lang=ts&"
import style0 from "./settingItem.vue?vue&type=style&index=0&id=527cde80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527cde80",
  null
  
)

export default component.exports